export enum MessageCourseMode {
  AllCourses = 'Todos los cursos',
  SelectCourses = 'Seleccionar cursos'
}
